/* eslint-disable react/forbid-prop-types */
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { DatePicker, TextareaInput } from 'components/FormControl';

function CommentModal({
  visible,
  onClose,
  onSubmit,
  handleSubmit,
  control,
  errors,
  data,
  isSubmitting,
}) {
  const { t } = useTranslation();

  return (
    <Dialog
      header={<p className="text-blue-500">{t('submitDocument.comment')}</p>}
      visible={visible}
      position="center"
      style={{ width: '600px' }}
      onHide={onClose}
      draggable={false}
    >
      <form onSubmit={handleSubmit(onSubmit)} className="p-fluid">
        <TextareaInput
          name="comment"
          label={t('submitDocument.comment')}
          control={control}
          errors={errors}
          row={6}
          isRequired
          defaultValue={data?.comment}
        />
        <div className="flex ">
          <DatePicker
            name="deadline"
            label={t('submitDocument.deadline')}
            control={control}
            errors={errors}
            className="w-4"
            isRequired
            defaultValue={new Date(data?.deadline)}
          />
        </div>
        <div className="flex justify-content-end gap-2">
          <Button
            type="button"
            label={t('employee.cancel')}
            className="w-7rem"
            severity="danger"
            onClick={onClose}
            autoFocus
          />
          <Button
            label={t('employee.ok')}
            className="w-7rem"
            severity="info"
            type="submit"
            disabled={isSubmitting}
          />
        </div>
      </form>
    </Dialog>
  );
}

CommentModal.propTypes = {
  visible: PropTypes.bool,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  handleSubmit: PropTypes.func,
  control: PropTypes.object,
  errors: PropTypes.object,
  // eslint-disable-next-line react/require-default-props
  data: PropTypes.object,
  isSubmitting: PropTypes.bool,
};

CommentModal.defaultProps = {
  visible: false,
  onClose: () => {},
  onSubmit: () => {},
  handleSubmit: () => {},
  control: {},
  errors: {},
  data: {},
  isSubmitting: false,
};

export default CommentModal;
